import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";

import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styles/AuthStyles.css";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [answer, setAnswer] = useState("");
  const navigate = useNavigate();

  const handleSumbit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`/api/v1/auth/forgotPassword`, {
        email,
        answer,
        newPassword,
      });
      debugger;
      if (res && res.data.success) {
        toast.success(res.data.message);
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };
  return (
    <Layout title={"forgot-password Ecommerce"}>
      <div className="form-container">
        <h1> Reset Password</h1>

        <form onSubmit={handleSumbit}>
          <div className="mb-3">
            <input
              type="email"
              placeholder="Your Email"
              className="form-control"
              id="exampleInputEmail"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              placeholder="Enter Your Nick Name"
              className="form-control"
              id="exampleInputEmail"
              value={answer}
              onChange={(e) => {
                setAnswer(e.target.value);
              }}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="password"
              placeholder="Your new Password"
              className="form-control"
              id="exampleInputPassword1"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <button type="submit" className="btn btn-primary">
              Reset
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default ForgetPassword;
